/* eslint-disable */
  // Do not edit this file, it is auto-generated at build time!
  // See scripts/generate-component-factory/index.ts to modify the generation of this file.
  
  import * as CoreAccordion from 'src/components/Core/CoreAccordion';
import * as CoreArticleAuthors from 'src/components/Core/CoreArticleAuthors';
import * as CoreCallToAction from 'src/components/Core/CoreCallToAction';
import * as CoreCarousel from 'src/components/Core/CoreCarousel';
import * as CoreContactsGrid from 'src/components/Core/CoreContactsGrid';
import * as CoreCredentials from 'src/components/Core/CoreCredentials';
import * as CoreCrossLinksGrid from 'src/components/Core/CoreCrossLinksGrid';
import * as CoreEmailDisclaimer from 'src/components/Core/CoreEmailDisclaimer';
import * as CoreEventDetails from 'src/components/Core/CoreEventDetails';
import * as CoreEventHero from 'src/components/Core/CoreEventHero';
import * as CoreFeaturedVideo from 'src/components/Core/CoreFeaturedVideo';
import * as CoreFormComponent from 'src/components/Core/CoreFormComponent';
import * as CheckboxInput from 'src/components/Core/CoreFormComponent/components/CheckboxInput';
import * as TextInput from 'src/components/Core/CoreFormComponent/components/TextInput';
import * as CoreGlobalNavigationFooter from 'src/components/Core/CoreGlobalNavigationFooter';
import * as PrimaryGroups from 'src/components/Core/CoreGlobalNavigationFooter/components/PrimaryGroups';
import * as CoreGlobalNavigationHeader from 'src/components/Core/CoreGlobalNavigationHeader';
import * as MegaMenu from 'src/components/Core/CoreGlobalNavigationHeader/components/MegaMenu';
import * as SearchInput from 'src/components/Core/CoreGlobalNavigationHeader/components/SearchInput';
import * as CoreHero from 'src/components/Core/CoreHero';
import * as CoreHomeHero from 'src/components/Core/CoreHomeHero';
import * as CoreLocationDetails from 'src/components/Core/CoreLocationDetails';
import * as CoreLocationsListingGroups from 'src/components/Core/CoreLocationsListingGroups';
import * as CoreMetadata from 'src/components/Core/CoreMetadata';
import * as CoreMetadataSearchBlox from 'src/components/Core/CoreMetadataSearchBlox';
import * as CoreNewsInsightsHero from 'src/components/Core/CoreNewsInsightsHero';
import * as CoreNewsInsightsSearch from 'src/components/Core/CoreNewsInsightsSearch';
import * as NewsInsightsSearchCombobox from 'src/components/Core/CoreNewsInsightsSearch/components/NewsInsightsSearchCombobox';
import * as NewsInsightsSearchResultsSummary from 'src/components/Core/CoreNewsInsightsSearch/components/NewsInsightsSearchResultsSummary';
import * as ResultsListing from 'src/components/Core/CoreNewsInsightsSearch/components/ResultsListing';
import * as CorePageJumpLinkNavigation from 'src/components/Core/CorePageJumpLinkNavigation';
import * as CorePeopleHero from 'src/components/Core/CorePeopleHero';
import * as CorePeopleSearch from 'src/components/Core/CorePeopleSearch';
import * as PeopleAlphaButtons from 'src/components/Core/CorePeopleSearch/components/PeopleAlphaButtons';
import * as PeopleSearchCombobox from 'src/components/Core/CorePeopleSearch/components/PeopleSearchCombobox';
import * as CoreRecentFeaturedNewsInsights from 'src/components/Core/CoreRecentFeaturedNewsInsights';
import * as CoreRelatedNewsInsightsGrid from 'src/components/Core/CoreRelatedNewsInsightsGrid';
import * as CoreRelatedPractices from 'src/components/Core/CoreRelatedPractices';
import * as CoreRichText from 'src/components/Core/CoreRichText';
import * as CoreServicesListingTabs from 'src/components/Core/CoreServicesListingTabs';
import * as AlphaServiceList from 'src/components/Core/CoreServicesListingTabs/components/AlphaServiceList';
import * as ServicesList from 'src/components/Core/CoreServicesListingTabs/components/ServicesList';
import * as CoreSiteSearch from 'src/components/Core/CoreSiteSearch';
import * as InfiniteScrollLoadMore from 'src/components/Core/CoreSiteSearch/components/InfiniteScrollLoadMore';
import * as SiteSearchCombobox from 'src/components/Core/CoreSiteSearch/components/SiteSearchCombobox';
import * as SiteSearchResultsListing from 'src/components/Core/CoreSiteSearch/components/SiteSearchResultsListing';
import * as SiteSearchResultsSummary from 'src/components/Core/CoreSiteSearch/components/SiteSearchResultsSummary';
import * as CoreSocialMediaEmbeds from 'src/components/Core/CoreSocialMediaEmbeds';
import * as CoreSocialShareTools from 'src/components/Core/CoreSocialShareTools';
import * as CoreTwoColumnLayout from 'src/components/Core/CoreTwoColumnLayout';
import * as CoreVideoGrid from 'src/components/Core/CoreVideoGrid';
  
  const components = new Map();
  components.set('CoreAccordion', CoreAccordion);
components.set('CoreArticleAuthors', CoreArticleAuthors);
components.set('CoreCallToAction', CoreCallToAction);
components.set('CoreCarousel', CoreCarousel);
components.set('CoreContactsGrid', CoreContactsGrid);
components.set('CoreCredentials', CoreCredentials);
components.set('CoreCrossLinksGrid', CoreCrossLinksGrid);
components.set('CoreEmailDisclaimer', CoreEmailDisclaimer);
components.set('CoreEventDetails', CoreEventDetails);
components.set('CoreEventHero', CoreEventHero);
components.set('CoreFeaturedVideo', CoreFeaturedVideo);
components.set('CoreFormComponent', CoreFormComponent);
components.set('CheckboxInput', CheckboxInput);
components.set('TextInput', TextInput);
components.set('CoreGlobalNavigationFooter', CoreGlobalNavigationFooter);
components.set('PrimaryGroups', PrimaryGroups);
components.set('CoreGlobalNavigationHeader', CoreGlobalNavigationHeader);
components.set('MegaMenu', MegaMenu);
components.set('SearchInput', SearchInput);
components.set('CoreHero', CoreHero);
components.set('CoreHomeHero', CoreHomeHero);
components.set('CoreLocationDetails', CoreLocationDetails);
components.set('CoreLocationsListingGroups', CoreLocationsListingGroups);
components.set('CoreMetadata', CoreMetadata);
components.set('CoreMetadataSearchBlox', CoreMetadataSearchBlox);
components.set('CoreNewsInsightsHero', CoreNewsInsightsHero);
components.set('CoreNewsInsightsSearch', CoreNewsInsightsSearch);
components.set('NewsInsightsSearchCombobox', NewsInsightsSearchCombobox);
components.set('NewsInsightsSearchResultsSummary', NewsInsightsSearchResultsSummary);
components.set('ResultsListing', ResultsListing);
components.set('CorePageJumpLinkNavigation', CorePageJumpLinkNavigation);
components.set('CorePeopleHero', CorePeopleHero);
components.set('CorePeopleSearch', CorePeopleSearch);
components.set('PeopleAlphaButtons', PeopleAlphaButtons);
components.set('PeopleSearchCombobox', PeopleSearchCombobox);
components.set('CoreRecentFeaturedNewsInsights', CoreRecentFeaturedNewsInsights);
components.set('CoreRelatedNewsInsightsGrid', CoreRelatedNewsInsightsGrid);
components.set('CoreRelatedPractices', CoreRelatedPractices);
components.set('CoreRichText', CoreRichText);
components.set('CoreServicesListingTabs', CoreServicesListingTabs);
components.set('AlphaServiceList', AlphaServiceList);
components.set('ServicesList', ServicesList);
components.set('CoreSiteSearch', CoreSiteSearch);
components.set('InfiniteScrollLoadMore', InfiniteScrollLoadMore);
components.set('SiteSearchCombobox', SiteSearchCombobox);
components.set('SiteSearchResultsListing', SiteSearchResultsListing);
components.set('SiteSearchResultsSummary', SiteSearchResultsSummary);
components.set('CoreSocialMediaEmbeds', CoreSocialMediaEmbeds);
components.set('CoreSocialShareTools', CoreSocialShareTools);
components.set('CoreTwoColumnLayout', CoreTwoColumnLayout);
components.set('CoreVideoGrid', CoreVideoGrid);
  
  
  function baseComponentFactory(componentName: string) {
    const component = components.get(componentName);
  
    return component?.Default || component?.default || component;
  }
    
  export function componentFactory(componentName: string) {
    return baseComponentFactory(componentName);
  }
  